import RemoveButton from '../RemoveButton/RemoveButton'
import classes from './StatusChip.module.scss'
import {
  HiCheckCircle,
  HiClock,
  HiExclamation,
  HiExclamationCircle,
  HiMinusCircle,
  HiXCircle
} from 'react-icons/hi'
import {
  InProgressCircle,
  SkippedStatus,
  StateRerunDot
} from '../Icons/Icons'
import type { ReactNode } from 'react'
import type { RequirementStatusLabel, RequirementStatusVariant, RunStatusLabel, Status } from '../types'

export interface BaseProps {
  trailingIcon?: ReactNode
  onRemoveClick?: () => void
}

export interface StatusProps {
  variant: Status
  label: RunStatusLabel
}

export interface RequiremntProps {
  variant: RequirementStatusVariant
  label: RequirementStatusLabel
}

type Props = BaseProps & (StatusProps | RequiremntProps)

const iconMap: Record<Status | RequirementStatusVariant, any> = {
  fail: HiExclamationCircle,
  pass: HiCheckCircle,
  passAfterRerun: StateRerunDot,
  cancelled: HiXCircle,
  error: HiExclamation,
  inProgress: InProgressCircle,
  pending: HiClock,
  verified: HiCheckCircle,
  unsuccessful: HiExclamationCircle,
  untested: HiClock,
  unassigned: HiXCircle,
  ignore: HiMinusCircle,
  skipped: SkippedStatus
}

const StatusChip = ({
  label,
  onRemoveClick,
  variant,
  trailingIcon
}: Props) => {
  const Icon = iconMap[variant]

  return (
    <span className={classes.StatusChip + ' ' + classes[variant]}>
      <span className={classes.iconColor}>
        <Icon
          aria-hidden
          size={18}
        />
      </span>
      <span>{label}</span>
      {
        trailingIcon &&
          <>
            <div className={classes.Divider} />
            {trailingIcon}
          </>
      }
      {
        onRemoveClick && <RemoveButton onClick={onRemoveClick} />
      }
    </span>
  )
}

export default StatusChip
